// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3ovcc","obliqueLineWrap":"membershipbadge_obliqueLineWrap__29iTo","obliqueLine":"membershipbadge_obliqueLine__3vi3H"};